declare namespace $ {

	type $mol_button_major__title_shm_knowledge_manual_editor_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_knowledge_manual_editor_2 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual_editor['save_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_knowledge_manual_editor_3 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual_editor['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_knowledge_manual_editor_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_knowledge_manual_editor_5 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual_editor['cancel_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_knowledge_manual_editor_6 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual_editor['cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_knowledge_manual_editor_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_knowledge_manual_editor_8 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual_editor['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_knowledge_manual_editor_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_textarea__value_shm_knowledge_manual_editor_10 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual_editor['draft'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_shm_knowledge_manual_editor_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_view__sub_shm_knowledge_manual_editor_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_knowledge_manual_editor extends $mol_page {
		save_enabled( ): boolean
		save( next?: any ): any
		Save( ): $mol_button_major
		cancel_enabled( ): boolean
		cancel( next?: any ): any
		Cancel( ): $mol_button_minor
		close( next?: any ): any
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		draft( next?: string ): string
		Input( ): $mol_textarea
		error( next?: string ): string
		Error( ): $mol_view
		api_url( ): string
		api_headers( ): Record<string, any>
		kind( ): string
		baseline( next?: any ): any
		load( next?: any ): any
		saved( next?: any ): any
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map